/**
 * Tokens related to rendering the <head> section of an HTML document.
 */

export enum HeadTag {
    CANONICAL_URL = "CanonicalURL",
}
